import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, profileRequest } from "../authConfig";
//import { getInfoUsers } from "../services/ApiGetUserInfo";
import { callMsGraphGroup } from "../graphGroup";
import LoadingSpinner from "../shared/LoadingSpinner";
import axios from "axios";

interface UserInfo {
  // Define your user info type here
  // Example: name: string;
}

interface Props {
  children: React.ReactNode;
}

export const PageLayout: React.FC<Props> = (props) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [accessTokenFetched, setAccessTokenFetched] = useState<boolean>(false);

  const request = { ...loginRequest, account: accounts[0] };
  const profileRequestOptions = { ...profileRequest, account: accounts[0] };

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        // ดึง accessToken จาก sessionStorage ก่อน ถ้ามีแล้วไม่ต้อง acquire ใหม่
        let accessToken = null;
        const storedAccessToken = sessionStorage.getItem("AccessToken");
        if (storedAccessToken) {
          try {
            accessToken = JSON.parse(storedAccessToken).value || storedAccessToken;
          } catch {
            accessToken = storedAccessToken;
          }
        }
        if (!accessToken) {
          const response = await instance.acquireTokenSilent(request);
          accessToken = response.accessToken;
          sessionSet("AccessToken", accessToken, 1);
        }
        // Save email to sessionStorage (only if not already set)
        if (accounts && accounts[0] && accounts[0].username && !sessionStorage.getItem('email')) {
          sessionStorage.setItem('email', accounts[0].username);
        }
        if (!cancelled) {
          setIsLoading(false);
          fetchMsGraphGroup();
        }
      } catch (error) {
        if (!cancelled) handleError(error);
      }
    };
    fetchData();
    return () => { cancelled = true; };
  }, [accounts]); // เพิ่ม accounts ใน dependency เผื่อ login เปลี่ยน

  const fetchMsGraphGroup = async () => {
    try {
      if (
        !sessionStorage.getItem("usergroup") ||
        sessionStorage.getItem("usergroup") === "undefined"
      ) {
        const response = await instance.acquireTokenSilent(
          profileRequestOptions
        );
        sessionSet("GraphAccessToken", response.accessToken, 60);
        
        // ดึงรูปโปรไฟล์และ group พร้อมกัน และรอให้เสร็จ
        await Promise.all([
          fetchUserPhoto(response.accessToken),
          callMsGraphGroup(response.accessToken).then(group => {
            sessionStorage.setItem("usergroup", JSON.stringify(group));
          })
        ]);
      } else {
        // ถ้ามี usergroup แล้ว แต่ยังไม่มี userPhoto ให้ดึงรูป
        const storedToken = sessionStorage.getItem("GraphAccessToken");
        if (storedToken && (!localStorage.getItem("userPhoto") || localStorage.getItem("userPhoto") === "")) {
          try {
            const tokenData = JSON.parse(storedToken);
            if (tokenData.value) {
              await fetchUserPhoto(tokenData.value);
            }
          } catch (e) {
            console.error("Error parsing stored token:", e);
          }
        }
      }
    } catch (error) {
      handleError(error);
    }
  };

    // เพิ่มฟังก์ชันดึงรูปโปรไฟล์จาก Microsoft Graph
  const fetchUserPhoto = async (accessToken: string) => {
    try {
      const existingPhoto = localStorage.getItem("userPhoto");
      
      // ตรวจสอบว่ามีรูปอยู่แล้วและไม่ใช่ค่า empty หรือ "no-photo"
      if (existingPhoto && existingPhoto !== "" && existingPhoto !== "no-photo") {
        console.log("User photo already exists in localStorage");
        return;
      }
      
      console.log("Fetching user photo from Microsoft Graph...");
      
      // ตรวจสอบว่ามี photo หรือไม่ก่อน
      const photoMetadataEndpoint = "https://graph.microsoft.com/v1.0/me/photo";
      const metadataResponse = await axios.get(photoMetadataEndpoint, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      
      if (metadataResponse.data && metadataResponse.data["@odata.mediaContentType"]) {
        console.log("User has profile photo, downloading...");
        
        const graphEndpoint = "https://graph.microsoft.com/v1.0/me/photo/$value";
        const response = await axios.get(graphEndpoint, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          responseType: "arraybuffer",
        });
        
        // ตรวจสอบ response.data ว่ามีข้อมูลหรือไม่
        if (response.data && response.data.byteLength > 0) {
          console.log("Photo downloaded successfully, converting to base64...");
          // ใช้ btoa สำหรับ browser (Buffer ใช้ได้เฉพาะ Node.js)
          const binary = new Uint8Array(response.data)
            .reduce((data, byte) => data + String.fromCharCode(byte), "");
          const base64data = `data:image/jpeg;base64,${btoa(binary)}`;
          
          // ใช้ try-catch สำหรับการ set localStorage
          try {
            localStorage.setItem("userPhoto", base64data);
            console.log("User photo saved to localStorage successfully");
          } catch (storageError) {
            console.error("Error saving photo to localStorage:", storageError);
          }
        } else {
          console.log("No photo data received");
          localStorage.setItem("userPhoto", "no-photo");
        }
      } else {
        console.log("User does not have a profile photo");
        // เก็บค่า default หรือ placeholder
        localStorage.setItem("userPhoto", "no-photo");
      }
    } catch (error: any) {
      console.error("Error fetching user photo:", error);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
      // เก็บค่า default เมื่อเกิด error
      try {
        localStorage.setItem("userPhoto", "no-photo");
      } catch (storageError) {
        console.error("Error setting fallback photo:", storageError);
      }
    }
  };

  const handleError = (error: any) => {
    console.log("PageLayout Error:", error);
    console.log("Error message:", error.message);

    // ป้องกันการ reload ที่อาจทำให้ localStorage หาย
    if (
      error.message === "AxiosError: Network Error" ||
      error.message === "AxiosError: Request failed with status code 500"
    ) {
      setIsLoading(false);
      // เพิ่ม delay เล็กน้อยก่อน reload เพื่อให้ localStorage มีเวลา save
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }

    if (error.message === "AxiosError: Request failed with status code 400") {
      setIsLoading(false);
     // setUserInfo(error.message);
    }
  };

  const sessionSet = (key: string, value: any, expirationInMin: number = 10) => {
    const expirationDate = new Date(
      new Date().getTime() + 60000 * expirationInMin
    );
    const newValue = {
      value: value,
      expirationDate: expirationDate.toISOString(),
    };
    sessionStorage.setItem(key, JSON.stringify(newValue));
  };

  return (
    <>
      {isLoading ? (
        <div className="layout-loading">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        props.children
      )}
    </>
  );
};
